import i18n from '@/config/translation'
import { chain, isEmpty } from 'lodash'

export const getTemplateTypeColumn = () => {
  return [
    {
      title: i18n.t('name'),
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: 'acronym',
      dataIndex: 'acronym',
      key: 'acronym',
      sorter: (a, b) => a.name.length - b.name.length,
      width: '19%',
    },

    {
      title: i18n.t('action'),
      dataIndex: 'action',
      key: 'action',
      width: '19%',
    },
  ]
}

export function validateSections(sections) {
  const duplicateSections = sections.reduce((a, e) => {
    a[e.name] = ++a[e.name] || 0
    return a
  }, {})
  const duplicatesSections = chain(
    sections.filter((e) => duplicateSections[e.name])
  )
    .groupBy((item) => item.title)
    .map((_, key) => key)
    .value()

  const duplicateSubSections = []
  const duplicateCheckPoints = []
  for (const item of sections) {
    const tmpDuplicate = item.sub_sections.reduce((a, e) => {
      a[e.name] = ++a[e.name] || 0
      return a
    }, {})
    const tmpDuplicateSubSection = chain(
      item.sub_sections.filter((e) => tmpDuplicate[e.name])
    )
      .groupBy((item) => item.title)
      .map((_, key) => key)
      .value()
    if (!isEmpty(tmpDuplicateSubSection)) {
      duplicateSubSections.push({
        sectionName: item.title,
        duplicates: tmpDuplicateSubSection,
      })
    }
  }

  for (const section of sections) {
    for (const item of section.sub_sections) {
      const tmpDuplicate = item.checkpoints.reduce((a, e) => {
        a[e.name] = ++a[e.name] || 0
        return a
      }, {})
      const tmpDuplicateCheckpoint = chain(
        item.checkpoints.filter((e) => tmpDuplicate[e.name])
      )
        .groupBy((item) => item.title)
        .map((_, key) => key)
        .value()
      if (!isEmpty(tmpDuplicateCheckpoint)) {
        duplicateCheckPoints.push({
          sectionName: section.title,
          subSectionName: item.title,
          duplicates: tmpDuplicateCheckpoint,
        })
      }
    }
  }

  const error =
    !isEmpty(duplicatesSections) ||
    !isEmpty(duplicateSubSections) ||
    !isEmpty(duplicateCheckPoints)

  return {
    error,
    duplicatesSections,
    duplicateSubSections: duplicateSubSections.flatMap(
      (item) => item.duplicates
    ),
    duplicateCheckPoints: duplicateCheckPoints.flatMap(
      (item) => item.duplicates
    ),
  }
}

export function transformInspectionType(data: any) {
  const list = data?.data?.data?.data?.map((item) => item)
  return {
    list,
    pagination: data?.data?.data?.pagination,
  }
}

export function removeIsNew(node) {
  if (Array.isArray(node)) {
    // dive into each array element
    node.forEach(removeIsNew)
  } else if (node && typeof node === 'object') {
    // remove the key on the current object
    delete node.is_new

    // then recurse on all remaining values
    Object.values(node).forEach(removeIsNew)

    /* ---------- immutable alternative ----------
    return Object.entries(node).reduce((acc, [k, v]) => {
      if (k !== 'is_new') acc[k] = removeIsNew(v);
      return acc;
    }, Array.isArray(node) ? [] : {});
    ------------------------------------------- */
  }
  return node
}
